import React, { createElement } from 'react';
import { Check, Star } from 'lucide-react';
import { CTAButton } from './CTAButton';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/8ZqqH66342L6cpWzYLx4FM/biblia_crochet_hero.webp';
// Preload ONLY the static hero image as early as possible (before first paint)
// so it becomes a fast, high-priority LCP element on mobile.
if (typeof document !== 'undefined' && !document.getElementById('hero-preload')) {
  const link = document.createElement('link');
  link.id = 'hero-preload';
  link.rel = 'preload';
  link.as = 'image';
  link.href = HERO_IMAGE;
  link.setAttribute('fetchpriority', 'high');
  document.head.appendChild(link);
}
export function Hero() {
  return <section className="relative pt-8 pb-12 px-6 overflow-hidden bg-gradient-to-b from-white to-cream" data-id="element-139">
      <div className="absolute top-[-10%] left-[-10%] w-64 h-64 bg-rose-light/30 rounded-full blur-3xl pointer-events-none" data-id="element-140" />
      <div className="absolute top-[20%] right-[-10%] w-72 h-72 bg-gold-light/20 rounded-full blur-3xl pointer-events-none" data-id="element-141" />

      <div className="max-w-4xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-142">
        {/* Social proof */}
        <div className="flex flex-col items-center gap-1 mb-6" data-id="element-143">
          <div className="flex gap-1 text-gold-dark" data-id="element-144">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-145" />)}
          </div>
          <span className="text-xs md:text-sm font-medium text-dark/70 uppercase tracking-wider" data-id="element-146">
            Más de 1.200 tejedoras felices
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-dark mb-2 leading-[1.1]" data-id="element-147">
          ACCEDÉ A MÁS DE{' '}
          <span className="text-rose-deep italic font-serif font-normal" data-id="element-148">
            4.000
          </span>{' '}
          PATRONES PREMIUM
        </h1>

        <h2 className="text-xl md:text-2xl lg:text-3xl font-serif text-gold-dark mb-4 leading-tight" data-id="element-149">
          Y CREÁ PIEZAS INCREÍBLES PARA USAR, REGALAR O VENDER
        </h2>

        {/* LCP element — static, eager, high priority. No animation in the first screen. */}
        <div className="relative w-64 sm:w-80 md:w-96 my-6 drop-shadow-2xl" data-id="element-150">
          <img src={HERO_IMAGE} alt="La Biblia del Crochet — La colección definitiva con más de 4.000 patrones" className="w-full h-auto object-contain" width={384} height={480} loading="eager" decoding="async"
        // @ts-ignore - fetchpriority is a valid HTML attribute
        fetchpriority="high" data-id="element-151" />
        </div>

        <p className="text-md md:text-lg text-dark/80 mb-6 max-w-2xl font-medium" data-id="element-152">
          Patrones organizados y listos para usar para que encuentres
          exactamente qué tejer en minutos.
        </p>

        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-y-2 gap-x-6 mb-8 text-sm md:text-base text-dark/80 font-semibold" data-id="element-153">
          {['Acceso inmediato', 'Más de 4.000 patrones', 'PDF listos para usar', 'Ideal para crear o vender'].map((benefit, i) => <div key={i} className="flex items-center gap-2" data-id="element-154">
              <div className="bg-gold/20 p-1 rounded-full" data-id="element-155">
                <Check className="w-4 h-4 text-gold-dark" data-id="element-156" />
              </div>
              <span data-id="element-157">{benefit}</span>
            </div>)}
        </div>

        <div className="w-full" data-id="element-158">
          <CTAButton size="large" data-id="element-159" />
        </div>
      </div>
    </section>;
}